<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card
          class="hero4"
          style="font-size:18px; width:auto; height:920px; background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border: 1px solid #00B058; border-radius: 20px;"
        >
          <b-row>
            <b-col
              cols="8"
            >
              <h3>Single line Diagram</h3>
            </b-col>
            <b-col
              cols="4"
              class="d-flex align-items-center justify-content-end"
            >
              <label class="mr-1"> เปิด/ปิดตู้ไฟ </label>
              <toggle-button
                class="mr-1"
                width="60"
                height="25"
                :sync="true"
                :value="this.switch.drv1_cmd"
                :color="{checked: '#29CD21', unchecked: '#FF0000', disabled: '#29CD21'}"
                :labels="{checked: 'เปิด', unchecked: 'ปิด'}"
                @change="onChangeActive($event)"
              />
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
            >
              <l-map
                ref="map"
                style="position: relative; font-size:18px; height:850px; width: 100%; background-color:rgba(0, 0, 0, 0); color:#ffffff; z-index: 0;"
                :crs="crs"
                :min-zoom="minZoom"
                :options="{scrollWheelZoom:false, zoomControl: false, doubleClickZoom: false, attributionControl:false,
                           touchZoom: false, tap: false, dragging: false}"
              >
                <l-image-overlay
                  :url="require('@/assets/images/icons/semcontrol/diagram/Diagram1.svg')"
                  :bounds="bounds"
                />
                <!-- L1volt1 -->
                <l-marker
                  :lat-lng="[-290, -602]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L1volt2 -->
                <l-marker
                  :lat-lng="[-320, -602]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L1volt3 -->
                <l-marker
                  :lat-lng="[-350, -602]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L1amp1 -->
                <l-marker
                  :lat-lng="[-290, -550]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L1amp2 -->
                <l-marker
                  :lat-lng="[-320, -550]"
                ><!-- Lamp2 -->
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L1amp3 -->
                <l-marker
                  :lat-lng="[-350, -550]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[0].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2volt1 -->
                <l-marker
                  :lat-lng="[-290, -470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2volt2 -->
                <l-marker
                  :lat-lng="[-320, -470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2volt3 -->
                <l-marker
                  :lat-lng="[-350, -470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2amp1 -->
                <l-marker
                  :lat-lng="[-290, -420]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2amp2 -->
                <l-marker
                  :lat-lng="[-320, -420]"
                ><!-- Lamp2 -->
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L2amp3 -->
                <l-marker
                  :lat-lng="[-350, -420]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[1].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3volt1 -->
                <l-marker
                  :lat-lng="[-290, -335]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3volt2 -->
                <l-marker
                  :lat-lng="[-320, -335]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3volt3 -->
                <l-marker
                  :lat-lng="[-350, -335]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3amp1 -->
                <l-marker
                  :lat-lng="[-290, -283]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3amp2 -->
                <l-marker
                  :lat-lng="[-320, -283]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L3amp3 -->
                <l-marker
                  :lat-lng="[-350, -283]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[2].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4volt1 -->
                <l-marker
                  :lat-lng="[-290, -188]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4volt2 -->
                <l-marker
                  :lat-lng="[-320, -188]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4volt3 -->
                <l-marker
                  :lat-lng="[-350, -188]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4amp1 -->
                <l-marker
                  :lat-lng="[-290, -138]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4amp2 -->
                <l-marker
                  :lat-lng="[-320, -138]"
                ><!-- Lamp2 -->
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L4amp3 -->
                <l-marker
                  :lat-lng="[-350, -138]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[3].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5volt1 -->
                <l-marker
                  :lat-lng="[-290, -55]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5volt2 -->
                <l-marker
                  :lat-lng="[-320, -55]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5volt3 -->
                <l-marker
                  :lat-lng="[-350, -55]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5amp1 -->
                <l-marker
                  :lat-lng="[-290, -2]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5amp2 -->
                <l-marker
                  :lat-lng="[-320, -2]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L5amp3 -->
                <l-marker
                  :lat-lng="[-350, -2]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[4].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6volt1 -->
                <l-marker
                  :lat-lng="[-290, 82]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6volt2 -->
                <l-marker
                  :lat-lng="[-320, 82]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6volt3 -->
                <l-marker
                  :lat-lng="[-350, 82]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6amp1 -->
                <l-marker
                  :lat-lng="[-290, 135]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6amp2 -->
                <l-marker
                  :lat-lng="[-320, 135]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L6amp3 -->
                <l-marker
                  :lat-lng="[-350, 135]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[5].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7volt1 -->
                <l-marker
                  :lat-lng="[-290, 212]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7volt2 -->
                <l-marker
                  :lat-lng="[-320, 212]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7volt3 -->
                <l-marker
                  :lat-lng="[-350, 212]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7amp1 -->
                <l-marker
                  :lat-lng="[-290, 264]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7amp2 -->
                <l-marker
                  :lat-lng="[-320, 264]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L7amp3 -->
                <l-marker
                  :lat-lng="[-350, 264]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[6].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8volt1 -->
                <l-marker
                  :lat-lng="[-290, 348]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8volt2 -->
                <l-marker
                  :lat-lng="[-320, 348]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8volt3 -->
                <l-marker
                  :lat-lng="[-350, 348]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8amp1 -->
                <l-marker
                  :lat-lng="[-290, 400]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8amp2 -->
                <l-marker
                  :lat-lng="[-320, 400]"
                ><!-- Lamp2 -->
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L8amp3 -->
                <l-marker
                  :lat-lng="[-350, 400]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[7].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9volt1 -->
                <l-marker
                  :lat-lng="[-290, 470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase1_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9volt2 -->
                <l-marker
                  :lat-lng="[-320, 470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase2_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9volt3 -->
                <l-marker
                  :lat-lng="[-350, 470]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase3_volt }} V</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9amp1 -->
                <l-marker
                  :lat-lng="[-290, 520]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase1_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9amp2 -->
                <l-marker
                  :lat-lng="[-320, 520]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase2_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- L9amp3 -->
                <l-marker
                  :lat-lng="[-350, 520]"
                >
                  <l-icon
                    class-name="someExtraClass"
                  >
                    <div class="headline">
                      <label> {{ items[8].phase3_amp }} A</label>
                    </div>
                  </l-icon>
                </l-marker>
                <!-- safety_swtich1 ----------------------------------------------------------->
                <l-marker
                  v-if="markers[0].safety_swtich === '0'"
                  :lat-lng="[375, -75]"
                  :icon="iconLred"
                />
                <!-- safety_swtich2 -->
                <l-marker
                  v-if="markers[1].safety_swtich === '0'"
                  :lat-lng="[375, -52]"
                  :icon="iconLred"
                />
                <!-- safety_swtich3 -->
                <l-marker
                  v-if="markers[2].safety_swtich === '0'"
                  :lat-lng="[375, -28]"
                  :icon="iconLred"
                />
                <!-- main_breaker1 -------------------------------------------------------------->
                <l-marker
                  v-if="markers[0].main_breaker === '0'|| markers[0].safety_swtich === '0'"
                  :lat-lng="[282, -75]"
                  :icon="iconLred"
                />
                <!-- main_breaker2 -->
                <l-marker
                  v-if="markers[1].main_breaker === '0'|| markers[1].safety_swtich === '0'"
                  :lat-lng="[282, -52]"
                  :icon="iconLred"
                />
                <!-- main_breaker3 -->
                <l-marker
                  v-if="markers[2].main_breaker === '0'|| markers[2].safety_swtich === '0'"
                  :lat-lng="[282, -28]"
                  :icon="iconLred"
                />
                <!-- Selector Switch -------------------------------------------------------------->
                <l-marker
                  v-if="markers[0].safety_swtich === '0'|| markers[0].main_breaker === '0'"
                  :lat-lng="[205, -198]"
                  :icon="iconSelect"
                />
                <!-- Selector Photo -->
                <l-marker
                  v-if="markers[0].photo_switch === '0'|| markers[0].safety_swtich === '0'|| markers[0].main_breaker === '0'"
                  :lat-lng="[179, -296]"
                  :icon="iconPhoto"
                />
                <!-- sub_breaker phase 1 -------------------------------------------------------------->
                <l-marker
                  v-if="markers[0].sub_breaker1 === '0' || markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[39, -252]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[0].sub_breaker2 === '0'|| markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[39, -87]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[0].sub_breaker3 === '0'|| markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[39, 85]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[0].sub_breaker4 === '0'|| markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[39, 254]"
                  :icon="iconLred"
                />
                <!-- sub_breaker phase2 ---------------------------->
                <l-marker
                  v-if="markers[1].sub_breaker1 === '0'|| markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[39, -217]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].sub_breaker2 === '0'|| markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[39, -52]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].sub_breaker3 === '0'|| markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[39, 120]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].sub_breaker4 === '0'|| markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[39, 278]"
                  :icon="iconLred"
                />
                <!-- sub_breaker phase3 --------------------------->
                <l-marker
                  v-if="markers[2].sub_breaker1 === '0'|| markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[39, -182]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].sub_breaker2 === '0'|| markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[39, -17]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].sub_breaker3 === '0'|| markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[39, 155]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].sub_breaker4 === '0'|| markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[39, 303]"
                  :icon="iconLred"
                />
                <!-- magnetic_contactor1 --------------------------->
                <l-marker
                  v-if="markers[0].magnetic_contactor1 === '0' || markers[0].sub_breaker1 === '0' || markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[-107, -252]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].magnetic_contactor1 === '0'|| markers[1].sub_breaker1 === '0' || markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[-107, -217]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].magnetic_contactor1 === '0'|| markers[2].sub_breaker1 === '0' || markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[-107, -181]"
                  :icon="iconLred"
                />
                <!-- magnetic_contactor2 --------------------------->
                <l-marker
                  v-if="markers[0].magnetic_contactor2 === '0' || markers[0].sub_breaker2 === '0' || markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[-107, -87]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].magnetic_contactor2 === '0' || markers[1].sub_breaker2 === '0' || markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[-107, -52]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].magnetic_contactor2 === '0' || markers[2].sub_breaker2 === '0' || markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[-107, -17]"
                  :icon="iconLred"
                />
                <!-- other --------------------------->
                <l-marker
                  v-if="markers[0].other === '0' || markers[0].sub_breaker3 === '0' || markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[-107, 85]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].other === '0' || markers[1].sub_breaker3 === '0' || markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[-107, 120]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].other === '0' || markers[2].sub_breaker3 === '0' || markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[-107, 155]"
                  :icon="iconLred"
                />
                <!-- spare --------------------------->
                <l-marker
                  v-if="markers[0].sub_breaker4 === '0' || markers[0].main_breaker === '0' || markers[0].safety_swtich === '0'"
                  :lat-lng="[-107, 253]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[1].sub_breaker4 === '0' || markers[1].main_breaker === '0' || markers[1].safety_swtich === '0'"
                  :lat-lng="[-107, 277]"
                  :icon="iconLred"
                />
                <l-marker
                  v-if="markers[2].sub_breaker4 === '0' || markers[2].main_breaker === '0' || markers[2].safety_swtich === '0'"
                  :lat-lng="[-107, 301]"
                  :icon="iconLred"
                />
                <!-- lighting1 --------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker1 === '0' && markers[1].sub_breaker1 === '0' && markers[2].sub_breaker1 === '0')
                    || (markers[0].magnetic_contactor1 === '0' && markers[1].magnetic_contactor1 === '0' && markers[2].magnetic_contactor1 === '0')
                    || (items[0].phase1_amp === '0.00' && items[0].phase2_amp === '0.00' && items[0].phase3_amp === '0.00')"
                  :lat-lng="[-290, -535]"
                  :icon="iconLight"
                />
                <!-- lighting2 --------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker1 === '0' && markers[1].sub_breaker1 === '0' && markers[2].sub_breaker1 === '0')
                    || (markers[0].magnetic_contactor1 === '0' && markers[1].magnetic_contactor1 === '0' && markers[2].magnetic_contactor1 === '0')
                    || (items[1].phase1_amp === '0.00' && items[1].phase2_amp === '0.00' && items[1].phase3_amp === '0.00')"
                  :lat-lng="[-290, -402]"
                  :icon="iconLight"
                />
                <!-- lighting3 --------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker1 === '0' && markers[1].sub_breaker1 === '0' && markers[2].sub_breaker1 === '0')
                    || (markers[0].magnetic_contactor1 === '0' && markers[1].magnetic_contactor1 === '0' && markers[2].magnetic_contactor1 === '0')
                    || (items[2].phase1_amp === '0.00' && items[2].phase2_amp === '0.00' && items[2].phase3_amp === '0.00')"
                  :lat-lng="[-290, -266]"
                  :icon="iconLight"
                />
                <!-- lighting4--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker2 === '0' && markers[1].sub_breaker2 === '0' && markers[2].sub_breaker2 === '0')
                    || (markers[0].magnetic_contactor2 === '0' && markers[1].magnetic_contactor2 === '0' && markers[2].magnetic_contactor2 === '0')
                    || (items[3].phase1_amp === '0.00' && items[3].phase2_amp === '0.00' && items[3].phase3_amp === '0.00')"
                  :lat-lng="[-290, -120]"
                  :icon="iconLight"
                />
                <!-- lighting5--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker2 === '0' && markers[1].sub_breaker2 === '0' && markers[2].sub_breaker2 === '0')
                    || (markers[0].magnetic_contactor2 === '0' && markers[1].magnetic_contactor2 === '0' && markers[2].magnetic_contactor2 === '0')
                    || (items[4].phase1_amp === '0.00' && items[4].phase2_amp === '0.00' && items[4].phase3_amp === '0.00')"
                  :lat-lng="[-290, 14]"
                  :icon="iconLight"
                />
                <!-- lighting6--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker2 === '0' && markers[1].sub_breaker2 === '0' && markers[2].sub_breaker2 === '0')
                    || (markers[0].magnetic_contactor2 === '0' && markers[1].magnetic_contactor2 === '0' && markers[2].magnetic_contactor2 === '0')
                    || (items[5].phase1_amp === '0.00' && items[5].phase2_amp === '0.00' && items[5].phase3_amp === '0.00')"
                  :lat-lng="[-289, 152]"
                  :icon="iconLight"
                />
                <!-- lighting7--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || (markers[0].sub_breaker2 === '0' && markers[1].sub_breaker2 === '0' && markers[2].sub_breaker2 === '0')
                    || (markers[0].magnetic_contactor2 === '0' && markers[1].magnetic_contactor2 === '0' && markers[2].magnetic_contactor2 === '0')
                    || (items[6].phase1_amp === '0.00' && items[6].phase2_amp === '0.00' && items[6].phase3_amp === '0.00')"
                  :lat-lng="[-289, 280]"
                  :icon="iconLight"
                />
                <!-- lighting8--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || ((markers[0].sub_breaker3 === '0' && markers[1].sub_breaker3 === '0') || (markers[0].sub_breaker3 === '0' && markers[2].sub_breaker3 === '0')||(markers[1].sub_breaker3 === '0' && markers[2].sub_breaker3 === '0'))
                    || (markers[0].other === '0' && markers[1].other === '0' && markers[2].other === '0')
                    || (items[7].phase1_amp === '0.00' && items[7].phase2_amp === '0.00' && items[7].phase3_amp === '0.00')"
                  :lat-lng="[-289, 416]"
                  :icon="iconLight"
                />
                <!-- lighting9--------------------------->
                <l-marker
                  v-if="(markers[0].safety_swtich === '0' && markers[1].safety_swtich === '0' && markers[2].safety_swtich === '0')
                    || (markers[0].main_breaker === '0' && markers[1].main_breaker === '0' && markers[2].main_breaker === '0')
                    || ((markers[0].sub_breaker3 === '0' && markers[1].sub_breaker3 === '0') || (markers[0].sub_breaker3 === '0' && markers[2].sub_breaker3 === '0')||(markers[1].sub_breaker3 === '0' && markers[2].sub_breaker3 === '0'))
                    || (markers[0].other === '0' && markers[1].other === '0' && markers[2].other === '0')
                    || (items[8].phase1_amp === '0.00' && items[8].phase2_amp === '0.00' && items[8].phase3_amp === '0.00')"
                  :lat-lng="[-289, 538]"
                  :icon="iconLight"
                />
              </l-map>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import {
  LMap, LImageOverlay, LMarker,
  LIcon,
} from 'vue2-leaflet'
import { CRS, icon, Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    BCol,
    BRow,
    BCard,
    LMap,
    LImageOverlay,
    LMarker,
    LIcon,
    // BButton,
  },
  data() {
    return {
      bounds: [[-390, -1500], [450, 1500]],
      iconSize: 64,
      crs: CRS.Simple,
      minZoom: -2,
      markers: [],
      items: [],
      iconLred: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Lred.svg'),
        iconSize: [75, 75],
        iconAnchor: [16, 37],
      }),
      iconSelect: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/handswitchred.svg'),
        iconSize: [74, 74],
        iconAnchor: [16, 37],
      }),
      iconPhoto: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/switchred.svg'),
        iconSize: [74, 74],
        iconAnchor: [16, 37],
      }),
      iconLight: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Lightingoff.svg'),
        iconSize: [60, 60],
        iconAnchor: [16, 37],
      }),
      switch: {
        semid: '',
        controller_id: 1,
        drv1_cmd: '',
      },
    }
  },
  computed: {
  },
  created() {
    this.checkSwith()
    this.getStatusSEM()
    this.getSemDevice()
    this.interval = setInterval(() => {
      this.getStatusSEM()
      this.getSemDevice()
      this.checkSwith()
    }, 10000)
  },
  mounted() {
    this.$refs.map.mapObject.invalidateSize()
  },
  methods: {
    onChangeActive(event) {
      this.$swal({
        title: '<span style="color:#000000">ต้องการปิดหรือเปิดตู้ไฟหรือไม่</span>',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.switch.drv1_cmd = event.value
          try {
            await axios.post('/swithSemControl', this.switch)
            if (event.value === true) {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">เปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            } else {
              this.$swal({
                icon: 'success',
                title: '<span style="color:#000000">ปิดเรียบร้อยแล้ว</span>',
                showConfirmButton: false,
                timer: 1000,
              })
            }
            this.getStatusSEM()
            this.getSemDevice()
            this.checkSwith()
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' กดเพื่อดำเนินการต่อ!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
    checkSwith() {
      axios
        .post('/checkSwithSemControl', { wid: this.$route.query.wid, controller_id: 1 })
        .then(response => {
          this.switch.semid = response.data[0].id
          if (response.data[0].drv1_cmd === 'CH1:CMD01:MT01=1;') {
            this.switch.drv1_cmd = true
          } else {
            this.switch.drv1_cmd = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStatusSEM() {
      axios
        .post('/markerSEMControl', { wid: this.$route.query.wid })
        .then(response => {
          this.markers = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSemDevice() {
      axios
        .post('/markerSEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style  lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.vue2leaflet-map{
  &.leaflet-container{
    height: 200px;
    width: 100%;
  }
}
.headline {
  text-align: right;
  width: 60px !important;
  height: auto !important;
}
label{
  font-size: 14px;
}

.hero4::before {
    content: "";
    background: url(~@/assets/images/icons/semcontrol/dark.jpg) ;
    position: absolute;
    /* margin: 20px 150px; */
    background-repeat:no-repeat;
    background-position: center;
    left: 0px;
    top : 0px;
    background-size: cover;
    width: 100%;
    height: 100%;
    opacity: 1.0;
    border-radius: 20px;
  }
</style>
